import { useUnit } from 'effector-react'
import * as React from 'react'

import {
  $errorWalletsRequest,
  $partnerWallet,
  $partnerWalletError,
  $wallets,
  getWallets,
  walletsMounted,
} from './model'

export const useWalletsWidget = () => {
  React.useEffect(() => {
    walletsMounted()
  }, [])

  const wallets = useUnit($wallets)
  const partnerWallet = useUnit($partnerWallet)
  const partnerWalletError = useUnit($partnerWalletError)
  const errorWalletsRequest = useUnit($errorWalletsRequest)

  const loading = useUnit(getWallets.pending)

  return {
    wallets,
    partnerWallet,
    loading,
    errorWalletsRequest,
    partnerWalletError,
  }
}
